import React from "react";
import { Link } from "react-router-dom";
import { ShoppingBag, Briefcase, ArrowRight } from "@phosphor-icons/react";

export default function RegisterChoice() {
  return (
    <div className="max-w-[1200px] mx-auto px-6 lg:px-10 py-20" data-testid="register-choice-page">
      <p className="label-eyebrow">Create your account</p>
      <h1 className="font-display text-4xl md:text-6xl font-black tracking-tighter leading-[0.9] mt-3 max-w-3xl">
        Who are you<br />joining as?
      </h1>
      <p className="text-black/60 mt-6 max-w-xl">
        Twinstars Plaza is two communities under one roof — guests booking services,
        and the team running them. Pick the path that fits you.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-16">
        <Link
          to="/register/customer"
          data-testid="choice-customer"
          className="group border border-black bg-white hover:bg-black hover:text-white transition-colors p-10 flex flex-col"
        >
          <ShoppingBag size={36} weight="duotone" className="opacity-80" />
          <h2 className="font-display text-3xl md:text-4xl font-black tracking-tighter mt-8">I'm a customer.</h2>
          <p className="text-sm opacity-70 mt-3">
            Book any of our 7 services — boxing, spa, gym, guesthouse, barbing, washing bay, laundry —
            with a single account, wallet credits and history.
          </p>
          <ul className="text-sm space-y-2 mt-8">
            <li>· Book any service in 60 seconds</li>
            <li>· Earn wallet credits on every visit</li>
            <li>· Track bookings, leave reviews</li>
          </ul>
          <div className="mt-auto pt-10 inline-flex items-center gap-2 font-semibold">
            Continue as customer <ArrowRight size={18} className="group-hover:translate-x-1 transition" />
          </div>
        </Link>

        <Link
          to="/register/staff"
          data-testid="choice-staff"
          className="group border border-black bg-black text-white hover:bg-[#FF3333] hover:border-[#FF3333] transition-colors p-10 flex flex-col"
        >
          <Briefcase size={36} weight="duotone" className="opacity-90" />
          <h2 className="font-display text-3xl md:text-4xl font-black tracking-tighter mt-8">I'm joining the team.</h2>
          <p className="text-sm opacity-80 mt-3">
            Apply for one of our 11 open roles — spa therapists, gym trainers, barbers,
            receptionists, security, supervisors and more.
          </p>
          <ul className="text-sm space-y-2 mt-8">
            <li>· Submit your application with documents</li>
            <li>· Track approval status in real time</li>
            <li>· Apply for additional roles later</li>
          </ul>
          <div className="mt-auto pt-10 inline-flex items-center gap-2 font-semibold">
            Continue as prospective staff <ArrowRight size={18} className="group-hover:translate-x-1 transition" />
          </div>
        </Link>
      </div>

      <p className="text-sm text-black/60 mt-12 text-center">
        Already have an account? <Link to="/login" className="underline">Sign in</Link>
      </p>
    </div>
  );
}
